import { config } from '@fortawesome/fontawesome-svg-core';
// Disable auto CSS injection for CSP compliance.
// Run as soon as possible.
// @see https://docs.fontawesome.com/web/dig-deeper/security/
config.autoAddCss = false;
// eslint-disable-next-line import/first
import { StyledFontAwesomeIcon } from './styled';
/**
 *
 * Don't use this component, use macro component exported at `@pocketlaw/tetris/falcon` instead.
 * This component is a thin wrapper around official `FontAwesomeIcon` component. and it will be injected by `falcon` at compile time.
 * It will allow us to pass default props and to access react context.
 *
 */
// eslint-disable-next-line camelcase
export function DO_NOT_USE_FaWrapper(props) {
    return <StyledFontAwesomeIcon data-icon="falcon" {...props}/>;
}
